// extracted by mini-css-extract-plugin
export default {"event-container":"event-container-977c"};